export enum GAME_TYPE {
	DOTA2 = 'Dota 2',
	CS2 = 'CS 2',
	LOL = 'LoL'
}

export interface TournamentEvent {
	startDate: Date | null;
	endDate: Date | null;
	name: string;
	gameType: GAME_TYPE | string;
	prize: string;
	description: string;
	img: string;
	url: string;
	imgQuest?: string;
	nameQuest?: string;
	statusQuest?: string;
	descriptionOne?: string;
	descriptionTwo?: string;
	tegQuest?: string;
	buttonUrl?: string;
	backgroundColor?: string;
	color?: string;
}

export interface GoogleSheetsResponse {
	values: string[][];
}

export interface EventColors {
	backgroundColor: string;
	color: string;
}

export type FilterGameType = GAME_TYPE | null; 